module.exports = __webpack_public_path__ + "js/stellarium-web-engine.d1dabf8f.wasm";